<template>
  <div class="cookie-list">
    <!-- CookieYes Cookies List start -->
    <div class="cky-audit-table-element"></div>
    <!-- CookieYes Cookies List end -->
  </div>
</template>

<script lang="ts" setup></script>

<style lang="scss">
.cookie-list {
  @include container;
  color: var(--dark-gray);
}

.cookie-list * {
  color: var(--dark-gray) !important;
}

.cookie-list a {
  background: none !important;
}
</style>
